module.exports = __webpack_public_path__ + "static/img/040_1.5483e4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_1.jpg
// module id = wpFe
// module chunks = 1